import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("po_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("po_token");
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const finishLogin = (token, u) => {
    localStorage.setItem("po_token", token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("po_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, finishLogin, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
